import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import worldNationalities from "../../../../auth/models/nationality";
import EuropeanNationality from "../../../../auth/models/european-nationality";
import { CitiesService } from "../../../../auth/service/cities.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { RoleService } from "../../../../auth/service/role.service";
import { UserFigureService } from "../../../../auth/service/user-figure.service";
import { CoreConfigService } from "../../../../../@core/services/config.service";
import { JobSiteService } from "../../../../auth/service/job-sites.service";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import * as moment from "moment/moment";
import { locale as italian } from "../../../../i18n/it";
import { CollaboratorsService } from "../../collaborators.service";
import nationsWithCodes from "app/auth/models/nations-with-codes";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-edit-my-profile-collaborator",
  templateUrl: "./edit-my-profile-collaborator.component.html",
  styleUrls: ["./edit-my-profile-collaborator.component.scss"],
})
export class EditMyProfileCollaboratorComponent implements OnInit {
  public formGroup: FormGroup;
  public pwdFormGroup: FormGroup;
  public addressResidence_FormGroup: FormGroup;
  public addressBilling_FormGroup: FormGroup;
  public active_table: string = "masterdata";
  public contentHeader: IContentHeader;
  public currentUser: any;
  public avatarImage: any;
  public today_date: string;
  public min_birthdate: string;
  public nationalities_list: Array<string> = worldNationalities;
  public europeanNationalities: Array<string> = EuropeanNationality;
  public me: ICurrentUser;
  public is_my_profile: boolean;
  public document_id_types: Array<object> = [];
  public file_document_id: any;
  public file_fiscal_code: any;
  public file_residence_permit: any;
  public email_domain: string;
  public fileNameFiscalCode: string = null;
  public fileNameDocumentId: string = null;
  public fileNamePermit: string = null;
  public type_nationality: any = null;
  public oldPasswordType: boolean;
  public newPasswordType: boolean;
  public confirmPasswordType: boolean;
  public isAnInternUser: boolean = false;
  public nationsWithCodes: { name: string; code: string }[] = nationsWithCodes;
  public isCopingResidence: boolean = false;

  constructor(
    public _citiesService: CitiesService,
    public _utilService: UtilsService,
    public _roleService: RoleService,
    public _userFigureService: UserFigureService,
    private _formBuilder: FormBuilder,
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreConfigService: CoreConfigService,
    public _authenticationService: AuthenticationService,
    public _jobSiteService: JobSiteService,
    private activated_route: ActivatedRoute,
    private _router: Router,
    private _collaboratorsService: CollaboratorsService,
    public _userService: UserService,
  ) {
    this.today_date = moment().format("YYYY-MM-DD");
    this.min_birthdate = moment().subtract(18, "year").format("YYYY-MM-DD");

    this.me = this._authenticationService.getCurrentUser();

    this.activated_route.paramMap.subscribe(async (params: ParamMap) => {
      const userIdentifier: any = params.get("user_identifier");

      this.is_my_profile = this.me.hash === userIdentifier;
      //Controllo che sia il mio profilo
      if (!this.is_my_profile) {
        await this._router.navigateByUrl("/dashboard/main");
        return false;
      }
      if (userIdentifier) {
        await this.loadUserData(userIdentifier);
      }
    });

    this.activated_route.queryParams.subscribe((params) => {
      if (params.section) {
        this.active_table = params.section;
      }
    });

    this._coreConfigService.config.subscribe((params: any) => {
      this.document_id_types = params.custom.document_id_types;
      this.email_domain = params.custom.email_domain;
    });

    this.formGroup = this._formBuilder.group({
      firstname: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      lastname: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      sex: new FormControl(null),
      site: new FormControl(null),
      birthday: new FormControl(null),
      addresses: new FormControl({}),
      send_welcome_email: new FormControl(null),
      birth_place: new FormControl(null),
      phone: new FormControl(null, [Validators.required, Validators.maxLength(15), Validators.minLength(9)]),
      email: new FormControl(null, [Validators.required, Validators.email]),
      private_email: new FormControl(null, [Validators.required, Validators.email]),
      fiscalcode: new FormControl(null, [Validators.required, Validators.maxLength(16), Validators.minLength(16)]),
      nationality: new FormControl(null, [Validators.required]),
      IBAN: new FormControl(null, [Validators.maxLength(34), Validators.minLength(15)]),
      badge_number: new FormControl(null, [Validators.maxLength(10), Validators.minLength(1)]),
      vat_number: new FormControl(null),
      civil_status: new FormControl(null),
      child_number: new FormControl(0, [Validators.min(0)]),
      working_city: new FormControl(null),
      document_type: new FormControl(null, [Validators.required]),
      document_number: new FormControl(null, [Validators.required]),
      document_valid_until: new FormControl(null, [Validators.required]),
      document_front_url: new FormControl(null),
      document_residence_permit_number: new FormControl(null),
      document_residence_permit_valid_until: new FormControl(null),
    });

    this.pwdFormGroup = this._formBuilder.group({
      current_password: new FormControl(""),
      new_password: new FormControl("", [Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})")]),
      confirm_password: new FormControl(""),
    });

    this.addressResidence_FormGroup = this._formBuilder.group({
      street: new FormControl("", [Validators.required, Validators.minLength(1)]),
      zipcode: new FormControl("", [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern("[0-9]+")]),
      city_id: new FormControl(null, [Validators.required, Validators.min(1)]),
      province_id: new FormControl(null, [Validators.required, Validators.min(1)]),
      external: new FormControl(false),
      country: new FormControl(null),
    });

    this.addressBilling_FormGroup = this._formBuilder.group({
      street: new FormControl(""),
      zipcode: new FormControl(""),
      city_id: new FormControl(null),
      province_id: new FormControl(null),
      external: new FormControl(false),
      country: new FormControl(null),
    });
  }

  ngOnInit() {}

  async loadUserData(identifier: any) {
    this.currentUser = await this._collaboratorsService.getCollaborator(identifier).catch(async () => {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "NOT_FOUND_USER" });
      await this._router.navigateByUrl("/dashboard/user/list/employee");
      return false;
    });
    //Controllo che l'utente sia un collaboratore
    if (!this._utilService.isACollaborator(this.currentUser)) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (!this.currentUser.vat_number) {
      this.isAnInternUser = true;
    }
    const residence: any = this.currentUser?.addresses?.find((c) => c.label === "residenza");
    const billing: any = this.currentUser?.addresses?.find((c) => c.label === "fatturazione");

    if (residence) {
      this.addressResidence_FormGroup.patchValue({
        street: residence.street,
        zipcode: residence.zipcode,
        city_id: residence.city_id,
        province_id: residence.province_id,
        country: residence.country ? residence.country : null,
        external: residence.country ? true : false,
      });
    }
    if (billing) {
      this.addressBilling_FormGroup.patchValue({
        street: billing.street,
        zipcode: billing.zipcode,
        city_id: billing.city_id,
        province_id: billing.province_id,
        country: billing.country ? billing.country : null,
        external: billing.country ? true : false,
      });
    }
    this.formGroup.patchValue({
      firstname: this.currentUser.firstname,
      lastname: this.currentUser.lastname,
      sex: this.currentUser.sex,
      site: this.currentUser.site_id,
      birthday: this.currentUser.birthday ? moment(this.currentUser.birthday).format("YYYY-MM-DD") : null,
      addresses: this.currentUser.addresses,
      birth_place: this.currentUser.birth_place_id,
      phone: this.currentUser.phone,
      email: this.currentUser.email,
      private_email: this.currentUser.private_email,
      fiscalcode: this.currentUser.fiscalcode,
      nationality: this.currentUser.identity_document.nationality,
      IBAN: this.currentUser.IBAN,
      civil_status: this.currentUser.civil_status,
      child_number: this.currentUser.child_number,
      working_city: this.currentUser.working_city_id,
    });

    if (this.currentUser.identity_document) {
      this.formGroup.patchValue({
        document_type: this.currentUser.identity_document.document_type,
        document_number: this.currentUser.identity_document.document_number,
        document_valid_until: this.currentUser.identity_document.document_valid_until,
        document_residence_permit_number: this.currentUser.identity_document.residence_permit_number,
        document_residence_permit_valid_until: this.currentUser.identity_document.residence_permit_valid_until,
      });
    }
    if (
      this.currentUser &&
      this.currentUser.identity_document &&
      this.currentUser.identity_document.nationality &&
      this.currentUser.identity_document.nationality.length > 0 &&
      this.currentUser.identity_document.nationality === "Italiana"
    ) {
      this.type_nationality = "Italiana";
    } else if (
      this.currentUser &&
      this.currentUser.identity_document.identity_document &&
      this.currentUser.identity_document.nationality &&
      this.currentUser.identity_document.nationality.length > 0 &&
      this.europeanNationalities.includes(this.currentUser.identity_document.nationality)
    ) {
      this.type_nationality = "UE";
    } else if (
      this.currentUser &&
      this.currentUser.identity_document &&
      this.currentUser.identity_document.nationality &&
      this.currentUser.identity_document.nationality.length > 0 &&
      this.currentUser.identity_document.nationality !== "Italiana" &&
      !this.europeanNationalities.includes(this.currentUser.identity_document.nationality)
    ) {
      this.type_nationality = "Extra Ue";
    }
    const headerBreadcrumbs: any = [
      {
        name: "Home",
        isLink: true,
        link: "/",
      },
    ];

    headerBreadcrumbs.push({
      name: italian.data.TITLES.PROFILE,
      isLink: true,
      link: `/dashboard/user/profile/${this.currentUser.hash}`,
    });
    headerBreadcrumbs.push({
      name: italian.data.EDIT,
      isLink: false,
    });

    this.contentHeader = {
      headerTitle: italian.data.TITLES.EDIT_PROFILE,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: headerBreadcrumbs,
      },
    };

    this.avatarImage = this.currentUser.avatar;
    //Controllo se ci sia una sede estera e nel caso aggiusto i validatori
    if (this.addressResidence_FormGroup.value.external) {
      this.manageExternalSiteResidence();
    }
    if (this.addressBilling_FormGroup.value.external) {
      this.manageExternalSiteLiving();
    }
    this._changeDetectorRef.detectChanges();
  }

  hasCapability(name: string) {
    return this._authenticationService.hasCapability(name);
  }

  handlerChangeOfficeEmail(event) {
    const value: string = event.target.value.toLowerCase();
    if (!value.includes(this.email_domain) && !value.includes("@")) {
      this.formGroup.patchValue({ email: value + this.email_domain });
    }
  }

  fieldHasErrors(field_name: string): boolean {
    return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
  }

  async copyResidence() {
    //Resetto i valori
    this.addressBilling_FormGroup.patchValue({
      street: null,
      zipcode: null,
      city_id: null,
      province_id: null,
      country: null,
    });

    this.addressBilling_FormGroup.patchValue({
      street: this.addressResidence_FormGroup.value.street,
      zipcode: this.addressResidence_FormGroup.value.zipcode,
      city_id: this.addressResidence_FormGroup.value.city_id,
      province_id: this.addressResidence_FormGroup.value.province_id,
      country: this.addressResidence_FormGroup.value.country,
      external: this.addressResidence_FormGroup.value.external,
    });

    this.manageExternalSiteLiving();
  }

  handlerChangeFileInput(event: any, what: string) {
    what === "fiscal-code" ? (this.fileNameFiscalCode = event.target.files[0].name) : null;
    what === "residence-permit" ? (this.fileNamePermit = event.target.files[0].name) : null;
    what === "document-id" ? (this.fileNameDocumentId = event.target.files[0].name) : null;
    this._utilService.convertFileToBase64(event, (e: any) => {
      const r = e.target.result;
      switch (what) {
        case "document-id":
          this.file_document_id = r;
          break;
        case "fiscal-code":
          this.file_fiscal_code = r;
          break;
        case "avatar":
          this.avatarImage = r;
          break;
        case "residence-permit":
          this.file_residence_permit = r;
          break;
      }
    });
  }

  setAutoProvince(address_label: string = "Residence") {
    const cityValue: number = this[`address${address_label}_FormGroup`].get("city_id").value;
    if (cityValue > 0) {
      const cityObj: any = this._citiesService.list.find((city: any) => city.id === cityValue);
      const province = this._citiesService.list.find((city: any) => city.initials === cityObj.initials && city.is_main === 1);
      this[`address${address_label}_FormGroup`].patchValue({ province_id: province.id });
    }
  }

  async save() {
    if (!this.is_my_profile) {
      return this._utilService.showSWALError({ text: "INSERT_AVATAR" });
    }
    if (!this.avatarImage) {
      await this._utilService.showSWALError({ text: "INSERT_AVATAR" });
      return false;
    }
    //Controllo alert campi mancanti
    let keyToShowError: any = [];
    Object.keys(this.formGroup.controls).map((key) => {
      if (this.formGroup.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });
    Object.keys(this.addressResidence_FormGroup.controls).map((key) => {
      if (this.addressResidence_FormGroup.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });
    Object.keys(this.addressBilling_FormGroup.controls).map((key) => {
      if (this.addressBilling_FormGroup.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });

    if (this.formGroup.invalid || this.addressResidence_FormGroup.invalid || this.addressBilling_FormGroup.invalid) {
      let textMessage = await this._utilService.translate("SOME_DATA_ARE_NOT_VALID");
      keyToShowError = await Promise.all(
        keyToShowError.map(async (key) => {
          key = await this._utilService.translate(key.toUpperCase());
          return key.toLowerCase();
        }),
      );
      keyToShowError.map((item, index: number = 0) => {
        index + 1 < keyToShowError.length ? (textMessage += item += ", ") : (textMessage += item += ".");
      });
      //id document
      if (!this.is_my_profile) {
        if (this.formGroup.controls.fiscalcode.status === "INVALID") {
          this.active_table = "id_document";
        }
      } else {
        if (
          !this.type_nationality ||
          this.formGroup.controls.fiscalcode.status === "INVALID" ||
          this.formGroup.controls.document_type.status === "INVALID" ||
          this.formGroup.controls.nationality.status === "INVALID" ||
          this.formGroup.controls.document_number.status === "INVALID" ||
          this.formGroup.controls.document_valid_until.status === "INVALID" ||
          this.formGroup.controls.document_residence_permit_number.status === "INVALID" ||
          this.formGroup.controls.document_residence_permit_valid_until.status === "INVALID"
        ) {
          this.active_table = "id_document";
        }
      }
      // addresses
      if (this.addressResidence_FormGroup.invalid || this.addressBilling_FormGroup.invalid) {
        this.active_table = "addresses";
      }
      //information
      if (this.formGroup.controls.private_email.status === "INVALID" || this.formGroup.controls.phone.status === "INVALID") {
        this.active_table = "informations";
      }
      //masterData
      if (this.formGroup.controls.firstname.status === "INVALID" || this.formGroup.controls.lastname.status === "INVALID") {
        this.active_table = "masterdata";
      }
      return this._utilService.showSWALEmptyField({ text: textMessage });
    }
    //Fine controllo alert campi mancanti

    let data: any = {
      firstname: this.formGroup.value.firstname,
      lastname: this.formGroup.value.lastname,
      sex: this.formGroup.value.sex,
      site: this.formGroup.value.site,
      birthday: this.formGroup.value.birthday,
      addresses: this.formGroup.value.addresses,
      send_welcome_email: this.formGroup.value.send_welcome_email,
      birth_place: this.formGroup.value.birth_place,
      phone: this.formGroup.value.phone,
      email: this.formGroup.value.email,
      private_email: this.formGroup.value.private_email,
      fiscalcode: this.formGroup.value.fiscalcode,
      nationality: this.formGroup.value.nationality,
      IBAN: this.formGroup.value.IBAN,
      badge_number: this.formGroup.value.badge_number,
      vat_number: this.formGroup.value.vat_number,
      civil_status: this.formGroup.value.civil_status,
      child_number: this.formGroup.value.child_number,
      working_city: this.formGroup.value.working_city,
      document_id: {
        type: this.formGroup.value.document_type,
        number: this.formGroup.value.document_number,
        valid_until: this.formGroup.value.document_valid_until,
        document_url: null,
        residence_permit_number: this.formGroup.value.document_residence_permit_number,
        residence_permit_valid_until: this.formGroup.value.document_residence_permit_valid_until,
        fiscalcode_url: null,
        residence_permit_url: null,
      },
    };
    /*  this.formGroup.value;
    data.document_id = {
      type: this.formGroup.value.document_type,
      number: this.formGroup.value.document_number,
      valid_until: this.formGroup.value.document_valid_until,
      residence_permit_number: this.formGroup.value.document_type,
      residence_permit_valid_until: this.formGroup.value.document_residence_permit_valid_until,
    }; */
    //Settiamo i campi public email e public phone se toggle spuntato
    if (data.phone && data.phone.length > 0) {
      data.phone = data.phone.replace(/ /g, ""); //Rimozione spazi
    }

    if (this.avatarImage && this.avatarImage !== this.currentUser.avatar) {
      await this._userService.uploadAvatar(this.currentUser.hash, this.avatarImage).catch(() => this._utilService.showSWALError({ text: "AVATAR_UPLOAD_ERROR" }));
    }

    const userMinioDir: string = `users/${this.currentUser.hash}/`;

    if ((this.file_document_id && (data.document_id.type || this.currentUser.document_id.type)) || this.file_fiscal_code) {
      const baseDocumentFileName: string = `${userMinioDir}documento-didentita/`;

      if (this.file_document_id) {
        const fileDocumentIdExt: string = this.file_document_id.split(";base64,")[0].split("/")[1];
        await this._utilService
          .upload_media("documents", baseDocumentFileName + (data.document_id.type || this.currentUser.document_id.type) + "." + fileDocumentIdExt, this.file_document_id)
          .then((response: any) => {
            data.document_id.document_url = baseDocumentFileName + response.url.split("/").pop();
          })
          .catch(() => this._utilService.showSWALError({ text: "ID_DOCUMENT_UPLOAD_ERROR" }));
      }

      if (this.file_fiscal_code) {
        const fileDocumentIdExt: string = this.file_fiscal_code.split(";base64,")[0].split("/")[1];
        await this._utilService
          .upload_media("documents", baseDocumentFileName + "fiscal-code." + fileDocumentIdExt, this.file_fiscal_code)
          .then((response: any) => {
            data.document_id.fiscalcode_url = baseDocumentFileName + response.url.split("/").pop();
          })
          .catch(() => this._utilService.showSWALError({ text: "FISCAL_CODE_UPLOAD_ERROR" }));
      }
    }

    if (this.file_residence_permit) {
      const fileExt: string = this.file_residence_permit.split(";base64,")[0].split("/")[1];
      await this._utilService
        .upload_media("documents", `${userMinioDir}permesso-di-soggiorno/file.${fileExt}`, this.file_residence_permit)
        .then((response: any) => {
          data.document_id.residence_permit_url = `${userMinioDir}permesso-di-soggiorno/` + response.url.split("/").pop();
        })
        .catch(() => this._utilService.showSWALError({ text: "RESIDENCE_PERMIT_UPLOAD_ERROR" }));
    }

    data.addresses = {};
    if (this.addressResidence_FormGroup.valid) {
      if (JSON.stringify(this.addressResidence_FormGroup.value) !== (this.currentUser.addresses.residenza || {})) {
        data.addresses.residenza = {
          city_id: this.addressResidence_FormGroup.value.city_id,
          country: this.addressResidence_FormGroup.value.country,
          province_id: this.addressResidence_FormGroup.value.province_id,
          street: this.addressResidence_FormGroup.value.street,
          zipcode: this.addressResidence_FormGroup.value.zipcode,
        };
      }
    } else {
      const residenceAddress: any = this.addressResidence_FormGroup.value;
      if (residenceAddress.street.length > 0 || residenceAddress.zipcode.length > 0 || residenceAddress.city_id > 0 || residenceAddress.province_id > 0) {
        await this._utilService.showSWALError({ text: "RESIDENCE_ADDRESS_NOT_COMPLETE" });
      }
    }

    if (this.addressBilling_FormGroup.valid) {
      if (JSON.stringify(this.addressBilling_FormGroup.value) !== JSON.stringify(this.currentUser.addresses.spedizione || {})) {
        data.addresses.spedizione = {
          city_id: this.addressBilling_FormGroup.value.city_id,
          country: this.addressBilling_FormGroup.value.country,
          province_id: this.addressBilling_FormGroup.value.province_id,
          street: this.addressBilling_FormGroup.value.street,
          zipcode: this.addressBilling_FormGroup.value.zipcode,
        };
      }
    } else {
      const shippingAddress: any = this.addressBilling_FormGroup.value;
      if (shippingAddress.street.length > 0 || shippingAddress.zipcode.length > 0 || shippingAddress.city_id > 0 || shippingAddress.province_id > 0) {
        await this._utilService.showSWALError({ text: "SHIPPING_ADDRESS_NOT_COMPLETE" });
      }
    }

    this._utilService.showLoading();
    return this._collaboratorsService
      .updateCollaborator(this.currentUser.hash, data)
      .then(async () => {
        this._utilService.hideLoading();
        if (this.currentUser.hash === this.me.hash) {
          await this._collaboratorsService.getCollaborator(this.currentUser.hash).then(async (response: any) => {
            let userLocalStorage = JSON.parse(localStorage.getItem("currentUser"));
            response.capabilities = userLocalStorage.capabilities;
            localStorage.setItem("currentUser", JSON.stringify(response));
            await this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_USER" });
            window.location.href = "/dashboard/user/profile/" + this.currentUser.hash;
          });
        } else {
          await this.loadUserData(this.currentUser.hash).then(async () => {
            await this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_USER" });
            await this._router.navigateByUrl("/dashboard/user/profile/" + this.currentUser.hash);
          });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_UPDATE_USER" });
      });
  }

  removePwdErrors(error: string) {
    const errors: any = this.pwdFormGroup.errors || {};
    delete errors[error];
    this.pwdFormGroup.setErrors(errors);
  }

  async changePassword() {
    const data: any = this.pwdFormGroup.value;

    if (!this.is_my_profile && !this.currentUser.capabilities.includes("change_others_passwords")) {
      return this._utilService.showSWALError({ text: "UNAUTHORIZED" });
    }

    if (String(data.current_password).length < 1 && String(data.new_password).length < 1 && String(data.confirm_password).length < 1) {
      return this._utilService.showSWALError({ text: "NOTHING_TO_UPDATE" });
    }

    if (RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})").test(data.new_password)) {
      this.removePwdErrors("weakPassword");
    } else {
      this.pwdFormGroup.setErrors({ weakPassword: true });
      return false;
    }

    if (String(data.new_password).trim() !== String(data.confirm_password).trim()) {
      this.pwdFormGroup.setErrors({ notSamePwd: true });
      return false;
    } else {
      this.removePwdErrors("notSamePwd");
    }

    delete data.confirm_password;

    await this._userService
      .change_password(this.currentUser.hash, data)
      .then(() => this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_USER_PASSWORD" }))
      .catch(() => this._utilService.showSWALError({ text: "ERROR_UPDATE_USER_PASSWORD" }));
  }

  togglePasswordTextType(which: string) {
    if (which === "old") {
      this.oldPasswordType = !this.oldPasswordType;
    }
    if (which === "new") {
      this.newPasswordType = !this.newPasswordType;
    }
    if (which === "confirm") {
      this.confirmPasswordType = !this.confirmPasswordType;
    }
  }

  async viewDocument(url: string) {
    await this._utilService.getFile(url);
  }

  setCountry() {
    this.formGroup.get("document_residence_permit_number").clearValidators();
    this.formGroup.get("document_residence_permit_number").clearValidators();
    this.formGroup.patchValue({
      nationality: "",
    });
    if (this.type_nationality == "Italiana") {
      this.formGroup.patchValue({
        nationality: "Italiana",
      });
    }
    if (this.type_nationality === "Extra Ue" && this.is_my_profile) {
      this.formGroup.controls.document_residence_permit_number.setValidators([Validators.required]);
      this.formGroup.controls.document_residence_permit_valid_until.setValidators([Validators.required]);
    }
  }

  manageExternalSiteResidence() {
    this.isCopingResidence = false;
    if (this.addressResidence_FormGroup.value.external) {
      this.addressResidence_FormGroup.get("country").addValidators(Validators.required);
      this.addressResidence_FormGroup.get("city_id").clearValidators();
      this.addressResidence_FormGroup.get("zipcode").clearValidators();
      this.addressResidence_FormGroup.get("province_id").clearValidators();
      this.addressResidence_FormGroup.patchValue({
        province_id: null,
        city_id: null,
        zipcode: null,
      });
    } else {
      this.addressResidence_FormGroup.patchValue({
        country: null,
      });
      this.addressResidence_FormGroup.get("country").clearValidators();
      this.addressResidence_FormGroup.get("province_id").addValidators(Validators.required);
      this.addressResidence_FormGroup.get("city_id").addValidators(Validators.required);
      this.addressResidence_FormGroup.get("zipcode").addValidators(Validators.required);
      this.addressResidence_FormGroup.get("zipcode").addValidators(Validators.minLength(5));
      this.addressResidence_FormGroup.get("zipcode").addValidators(Validators.maxLength(5));
      this.addressResidence_FormGroup.get("zipcode").addValidators(Validators.pattern("[0-9]+"));
    }
    this.addressResidence_FormGroup.get("country").updateValueAndValidity();
    this.addressResidence_FormGroup.get("city_id").updateValueAndValidity();
    this.addressResidence_FormGroup.get("zipcode").updateValueAndValidity();
    this.addressResidence_FormGroup.get("province_id").updateValueAndValidity();
  }

  manageExternalSiteLiving() {
    this.isCopingResidence = false;
    if (this.addressBilling_FormGroup.value.external) {
      if (this.is_my_profile) {
        this.addressBilling_FormGroup.get("country").addValidators(Validators.required);
        this.addressBilling_FormGroup.get("city_id").clearValidators();
        this.addressBilling_FormGroup.get("zipcode").clearValidators();
        this.addressBilling_FormGroup.get("province_id").clearValidators();
      }
      this.addressBilling_FormGroup.patchValue({
        province_id: null,
        city_id: null,
        zipcode: null,
      });
    } else {
      this.addressBilling_FormGroup.patchValue({
        country: null,
      });
      if (this.is_my_profile) {
        this.addressBilling_FormGroup.get("country").clearValidators();
        this.addressBilling_FormGroup.get("province_id").addValidators(Validators.required);
        this.addressBilling_FormGroup.get("city_id").addValidators(Validators.required);
        this.addressBilling_FormGroup.get("zipcode").addValidators(Validators.required);
        this.addressBilling_FormGroup.get("zipcode").addValidators(Validators.minLength(5));
        this.addressBilling_FormGroup.get("zipcode").addValidators(Validators.maxLength(5));
        this.addressBilling_FormGroup.get("zipcode").addValidators(Validators.pattern("[0-9]+"));
      }
    }
    if (this.is_my_profile) {
      this.addressBilling_FormGroup.get("country").updateValueAndValidity();
      this.addressBilling_FormGroup.get("city_id").updateValueAndValidity();
      this.addressBilling_FormGroup.get("zipcode").updateValueAndValidity();
      this.addressBilling_FormGroup.get("province_id").updateValueAndValidity();
    }
  }
}
